import { render, staticRenderFns } from "./home_project8.vue?vue&type=template&id=f29f0d0a&scoped=true&"
import script from "./home_project8.vue?vue&type=script&lang=js&"
export * from "./home_project8.vue?vue&type=script&lang=js&"
import style0 from "./home_project8.vue?vue&type=style&index=0&id=f29f0d0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29f0d0a",
  null
  
)

export default component.exports